/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

window.Parsley.addValidator('licenseAssignedNumber', {
  validateString(value, requirement) {
    const regex = /[a-zA-Z]{2}[0-9]{6}/;
    const regexOptional = /[a-zA-Z]{2}[0-9]{6}[a-zA-Z]/;
    const eightChar = regex.test(value) && value.length === 8;
    const nineChar = regexOptional.test(value) && value.length === 9;
    return eightChar || nineChar;
  },
  messages: {
    en: 'Must be valid License/Assigned Number, with 2 letters followed by 6 digits with an optional letter',
  },
});
